/** How much of a page each ad size takes up (Full 1, Half ½, Quarter ¼, Fifth ⅕, Eighth ⅛, Business Card 1/16). */
export function pageShare(size: string | null | undefined) {
  const s = (size ?? '').toLowerCase();
  if (s.includes('full')) return 1;
  if (s.includes('half') || s.includes('1/2')) return 0.5;
  if (s.includes('quarter') || s.includes('1/4')) return 0.25;
  if (s.includes('fifth') || s.includes('1/5')) return 0.2;
  if (s.includes('eighth') || s.includes('1/8')) return 0.125;
  if (s.includes('business card')) return 0.0625;
  return 0;
}
export const fmtPages = (n: number) => (Math.round(n * 100) / 100).toString();
